import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DefaultFolderRequestDto } from 'src/api/FiretrolApiClient';
import { defaultFolderApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

// `documentTemplate.save` invalidates `documentTemplates.all()`, the key prefix
// that covers both the template list and each template's folder tree.
export function useCreateDocumentTemplateFolder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      templateId,
      request,
    }: {
      templateId: string;
      request: DefaultFolderRequestDto;
    }) => defaultFolderApiClient.createTemplateFolder(templateId, request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('documentTemplate.save', qc),
  });
}

export function useUpdateDocumentTemplateFolder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      folderId,
      request,
    }: {
      folderId: string;
      request: DefaultFolderRequestDto;
    }) => defaultFolderApiClient.updateFolder(folderId, request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('documentTemplate.save', qc),
  });
}

export function useDeleteDocumentTemplateFolder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (folderId: string) =>
      defaultFolderApiClient.removeFolder(folderId),
    onSettled: () => invalidateFor('documentTemplate.save', qc),
  });
}
